export enum autoplayAssetConfig {
    autoplayBaseImage = "",
    clickedNumberButton = "assets/autoplay/autoplay_btn_over.png",
    unclickedNumberButton = "assets/autoplay/autoplay_btn_up.png",
    toggleButtonOnImage = "",
    toggleButtonOffImage = "",
    meterImage = "assets/autoplay/meter.png",
    sliderDot = "assets/autoplay/slider_dot.png",
    //autoplayButtonsJson = "assets/autoplay/autoplay.json",
    autoplayDesktopAssets = "assets/autoplay/autoplay_desktop_assets.json",
}